import { Position } from 'reactflow';
import { applyVueInReact } from 'vuereact-combined';

import { HiddenHandle } from './common';
import { NodeProps } from '../types';
import ToolTriggerSection from '@/components/FlowTree/ToolTriggerSection.vue';
const VueToolTriggerSection = applyVueInReact(ToolTriggerSection);

type NodeData = NodeProps['data'];
type ToolTriggerNodeProps = Omit<NodeProps, 'data'> & {
	data: {
		workflow: NonNullable<NodeData['workflow']>;
		node: NonNullable<NodeData['node']>;
	};
};

export default function ToolTriggerNode({ data, sourcePosition = Position.Top, targetPosition = Position.Bottom }: ToolTriggerNodeProps) {
	return (
		<>
			<HiddenHandle type="source" position={sourcePosition} />
			<VueToolTriggerSection workflow={data.workflow} />
			<HiddenHandle type="target" position={targetPosition} />
		</>
	);
}
